import React, { Component } from 'react'
import Select, { Creatable } from 'react-select-plus'
import { Toggle, Input } from '@driftt/tide-core-legacy'
import cx from 'classnames'
import { flatMap } from 'lodash'

import './style.styl'

const DEFAULT_SELECT_OPTIONS = {
  multi: false,
  searchable: true,
  autoFocus: false,
  clearable: false
}

const getCustomValuePrompt = (label) => {
  return (
    <div className="drift-select-option-create">
      <p>Set static value "{label}"</p>
      <p>This is <strong>not</strong> a Drift Attribute</p>
    </div>
  )
}

const resolveSelectOptionForIntegration = (selectProperty) => ({ label: selectProperty.displayName, value: selectProperty.name })
const resolveSelectOptionForDrift = (selectProperty) => ({ label: selectProperty.label, value: selectProperty.value })

const resolveSelectOptions = (selectProperties, resolveSelectOption) => {

  const reducer = (accumulator, currentValue) => {
    if (!currentValue) return accumulator
    let typeArray = accumulator[currentValue.type] || { label: currentValue.type, options: []}
    typeArray.options.push(resolveSelectOption(currentValue))
    accumulator[currentValue.type] = typeArray
    return accumulator
  }

  const initialValue = {}
  return flatMap(selectProperties.reduce(reducer, initialValue))
}

class AttributeMappingRow extends Component {

  constructor(props) {
    super(props)

    this.state = {
      driftAttributes: _.cloneDeep(props.driftAttributes),
      staticValues: this.setupStaticValues(props),
      isTypeDirty: false
    }

    this.setupStaticValues(props)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ staticValues: this.setupStaticValues(nextProps) })
  }

  setupStaticValues = props => {
    if (!!props.mapping.defaultValue && !props.mapping.driftAttribute) {
      return [{ label: props.mapping.defaultValue.toString(), value: props.mapping.defaultValue }]
    }
    return []
  }

  isMappingEditable(mapping) {
    return !_.isUndefined(mapping.editable) ? mapping.editable : true
  }

  renderIntegrationLabel(property) {
    if (!property) return

    const { displayName, required } = property
    const formatDisplayName = () => (
      <div className="integration-mapping-display-name">
        <strong className={required && 'required'}>* </strong>
        <span>{displayName}</span>
      </div>
    )

    return displayName ? formatDisplayName() : ''
  }

  createDefaultPropertyMapping = (value) => {
    const { mapping, index } = this.props
    const staticValues = [...this.state.staticValues]
    staticValues.push(value)

    this.setState({ staticValues: staticValues })
    
    mapping.defaultValue = value
    mapping.static = true

    this.props.updateMapping(index, mapping)
  }

  createStaticPropertyMapping = (value) => {
    const { mapping, index } = this.props
    const staticValues = [...this.state.staticValues]
    staticValues.push(value)

    this.setState({ staticValues: staticValues })

    mapping.driftAttribute = null
    mapping.defaultValue = value
    mapping.static = true

    this.props.updateMapping(index, mapping)
  }

  renderDefaultAttributeTextBox(defaultValue, driftValue, disabled){
    return ( driftValue && !disabled ) ? 
      <Input type="text" placeholder="Optional" defaultValue={defaultValue || ""} value={this.state.value} onChange={this.handleInputChange}/> :
      <Input className="uneditable" placeholder="N/A" disabled={true}/> 
  }
    handleInputChange = (e) => this.createDefaultPropertyMapping(e.target.value)


  updateDriftPropertyInMapping = (value) => {
    const { mapping, index } = this.props
    if (!!_.find(this.state.staticValues, { value: value })) {	
      mapping.defaultValue = value	
      mapping.driftAttribute = null	
    } else {	
      mapping.driftAttribute = value	
    }

    if (this.state.isTypeDirty) {
      this.setState({ isTypeDirty: false })
    }
    this.props.updateMapping(index, mapping)
  }

  clearDriftAttributeSelectionIfTypeChanged(value) {
    const { mapping, integrationAttributes } = this.props

    const currentIntegrationAttribute = _.find(integrationAttributes, { name: mapping.integrationAttribute })

    if (currentIntegrationAttribute) {
      const newIntegrationAttribute = _.find(integrationAttributes, { displayName: value.label })
      if (currentIntegrationAttribute.type !== newIntegrationAttribute.type) {
        this.setState({ isTypeDirty: true })
      }
    }
  }

  updateIntegrationFieldInMapping = (value) => {
    const { mapping, index } = this.props

    this.clearDriftAttributeSelectionIfTypeChanged(value)
    mapping.integrationAttribute = value ? value.value : null

    this.props.updateMapping(index, mapping)
  }

  updateIsOverwritableInMapping = () => {
    const { mapping, index } = this.props
    mapping.isOverwritable = !mapping.isOverwritable
    this.props.updateMapping(index, mapping)
  }

  renderDriftAttributeSelect(selectedProperty, disabled) {
    const { staticValues, isTypeDirty } = this.state
    const { driftAttributes } = this.props
    const availableAttributes = [...driftAttributes, ...staticValues]
    const selectedValue = (!isTypeDirty && !!selectedProperty) ? availableAttributes.filter(property => property.value == selectedProperty)[0] : null
    
    selectedValue && delete selectedValue.className

    const reducedProps = resolveSelectOptions(availableAttributes, resolveSelectOptionForDrift)
  
    const options = {
      value: selectedValue,
      options: reducedProps,
      className: "drift-attribute-mapping",
      disabled: disabled,
      promptTextCreator: (label) => getCustomValuePrompt(label),
      onNewOptionClick: (value) => this.createStaticPropertyMapping(value.value),
      onChange: (value) => this.updateDriftPropertyInMapping(value.value)
    }

    const selectOptions = _.assign({}, options, DEFAULT_SELECT_OPTIONS)
    return (<Creatable {...selectOptions} />)
  }

  renderIntegrationAttributeSelect(selectedProperty) {
    const { integrationAttributes } = this.props
    const attributes = integrationAttributes || []

    const supportedProperties = attributes.filter(property => !property.unsupported && !property.required)

    const reducedProps = resolveSelectOptions(supportedProperties, resolveSelectOptionForIntegration)

    const options = {
      value: selectedProperty,
      options: reducedProps,
      onChange: (value) => this.updateIntegrationFieldInMapping(value)
    }
    const selectOptions = _.assign({}, options, DEFAULT_SELECT_OPTIONS)
    return (<Select {...selectOptions} />)
  }
  
  renderMappingType = ({ driftAttribute, defaultValue, matchedIntegrationAttribute }) => {
    
    if (driftAttribute && matchedIntegrationAttribute && matchedIntegrationAttribute.type) {
      return <span className="type-field">{matchedIntegrationAttribute.type.toLowerCase()}</span>
    }

    if (!driftAttribute && defaultValue) {
      return <span className="static-value">Static Value</span>
    }

    return null
  }

  render() {
    const { mapping, index, integrationAttributes, allowAttributeDefaults, allowAttributeOverwrites } = this.props
    const { integrationAttribute, driftAttribute, defaultValue, isOverwritable } = mapping

    const matchedIntegrationAttribute = _.find(integrationAttributes, { name: integrationAttribute })
    const isRequired = matchedIntegrationAttribute ? matchedIntegrationAttribute.required : false
    const isUneditable = !this.isMappingEditable(mapping)
    const staticOrDriftProperty = driftAttribute || defaultValue

    const integrationProperty = (isRequired || isUneditable)
      ? this.renderIntegrationLabel(matchedIntegrationAttribute)
      : this.renderIntegrationAttributeSelect(integrationAttribute, index)

    const typeValue = this.renderMappingType({ driftAttribute, defaultValue, matchedIntegrationAttribute })

    return (
      <tr className={isUneditable && 'un-editable'}>
        <td className="delete-mapping-checkbox"><input disabled={(isUneditable || isRequired)} value={index} type="checkbox" onChange={this.props.updateDeleteProperties} /></td>
        <td className="mapping-drift-attribute">{isUneditable ? this.renderDriftAttributeSelect(staticOrDriftProperty, true, index)  : this.renderDriftAttributeSelect(staticOrDriftProperty, false,index)}</td>
        {allowAttributeDefaults && <td className="mapping-drift-attribute">{this.renderDefaultAttributeTextBox(defaultValue, driftAttribute, isUneditable)}</td>}
        <td className="type-column">{typeValue}</td>
        <td>{integrationProperty}</td>
        { allowAttributeOverwrites != false &&
          <td className="overwrite-column"><Toggle checked={isOverwritable} onChange={this.updateIsOverwritableInMapping}/></td>
        }
      </tr>
    )
  }
}

export default AttributeMappingRow



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/AttributeMappingRow/index.js